import React from 'react';

import { useTranslation } from 'react-i18next';

import NewTodo from './NewTodo';
import DialogTodoItem from './DialogTodoItem';

import {
  Button, Dialog, DialogContent, DialogTitle, DialogActions, Divider
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  divider: {
    margin: '30px auto'
  }
});

const TodosDialog = ({ objectiveId, open, handleClose, todos, onSubmitSuccess, status }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Dialog open={ open } fullWidth={ true } maxWidth={ 'md' } onClose={ handleClose }>
      <DialogTitle>{ t('objective.todos.dialog.title') }</DialogTitle>
      <DialogContent>
        { todos.map(todo => (
          <DialogTodoItem
            key={ todo.id }
            todoToUpdate={ todo }
            objectiveId={ objectiveId }
            onSubmitSuccess={ onSubmitSuccess }
            status={ status }
          />
        ))}
        <Divider className={ classes.divider } />
        <NewTodo
          objectiveId={ objectiveId }
          onSubmitSuccess={ onSubmitSuccess }
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={ handleClose }
          color="primary"
        >
          { t('objective.todos.dialog.close.btn') }
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TodosDialog;
